var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgNotSelected(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 28 28",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    width: 28,
    height: 28,
    fill: "#383A36",
    rx: 4
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M14 7c-3.864 0-7 3.136-7 7s3.136 7 7 7 7-3.136 7-7-3.136-7-7-7Zm0 12.6A5.598 5.598 0 0 1 8.4 14c0-1.295.441-2.485 1.183-3.43l7.847 7.847A5.532 5.532 0 0 1 14 19.6Zm4.417-2.17L10.57 9.583A5.532 5.532 0 0 1 14 8.4c3.094 0 5.6 2.506 5.6 5.6a5.532 5.532 0 0 1-1.183 3.43Z"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "not-selected-a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h28v28H0z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNotSelected);
export default __webpack_public_path__ + "static/media/not_selected.5d4ffc694ce22b181732d90534a31932.svg";
export { ForwardRef as ReactComponent };